// src/components/SuppliersLeftPanel.jsx
import React from "react";

const SuppliersLeftPanel = ({ openApplicationModal, activeTab, setActiveTab }) => {
  return (
    <div className="space-y-8">
      {/* Application Banner */}
      <div className="bg-gradient-to-r from-blue-600 to-emerald-600 rounded-4xl p-8 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative z-10 text-center">
          <h3 className="text-2xl font-bold mb-4">申请成为入围供应商</h3>
          <p className="text-blue-100 mb-6 text-sm">
            欢迎符合资质的优秀企业加入我们的供应链体系
          </p>
          <button
            onClick={openApplicationModal}
            className="bg-white text-blue-600 px-6 py-3 rounded-2xl font-bold text-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-300 shadow-lg w-full"
          >
            立即申请
          </button>
        </div>
      </div>

      {/* Qualification Requirements Tabs */}
      <div className="bg-white p-6 rounded-4xl shadow-xl border border-gray-100">
        <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">入围供应商资格要求</h3>
        <div className="flex justify-center mb-4">
          <div className="inline-flex bg-gray-100 p-1 rounded-xl">
            <button
              onClick={() => setActiveTab("process")}
              className={`px-4 py-2 rounded-lg font-medium text-sm ${
                activeTab === "process"
                  ? "bg-blue-600 text-white shadow-md"
                  : "text-gray-600 hover:text-blue-600"
              }`}
            >
              申请流程
            </button>
            <button
              onClick={() => setActiveTab("requirements")}
              className={`px-4 py-2 rounded-lg font-medium text-sm ${
                activeTab === "requirements"
                  ? "bg-blue-600 text-white shadow-md"
                  : "text-gray-600 hover:text-blue-600"
              }`}
            >
              基本要求
            </button>
            <button
              onClick={() => setActiveTab("benefits")}
              className={`px-4 py-2 rounded-lg font-medium text-sm ${
                activeTab === "benefits"
                  ? "bg-blue-600 text-white shadow-md"
                  : "text-gray-600 hover:text-blue-600"
              }`}
            >
              合作优势
            </button>
          </div>
        </div>

        <div className="text-sm text-gray-700 pr-2">
          {activeTab === "requirements" && (
            <div className="space-y-3">
              <h4 className="font-semibold text-gray-900">基本资质</h4>
              <ul className="list-disc pl-5 space-y-1">
                <li>具有独立法人资格，持有有效营业执照</li>
                <li>具有良好的商业信誉和健全的财务会计制度</li>
                <li>近三年内无重大违法记录</li>
                <li>依法缴纳税收和社会保障资金的良好记录</li>
                <li>具有履行合同所必需的设备和专业技术能力</li>
              </ul>
              <h4 className="font-semibold text-gray-900 mt-4">专业能力</h4>
              <ul className="list-disc pl-5 space-y-1">
                <li>具备相关产品/服务的专业资质证书</li>
                <li>拥有专业技术团队和完善的售后服务体系</li>
                <li>具备同类项目成功案例和业绩证明</li>
                <li>产品质量符合国家标准或行业标准</li>
                <li>具有完善的质量管理体系和安全生产管理制度</li>
                <li>具有持续创新能力，能提供技术升级服务</li>
              </ul>
            </div>
          )}

          {activeTab === "process" && (
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <span className="w-6 h-6 bg-blue-100 text-blue-800 rounded-full flex items-center justify-center text-xs font-bold">1</span>
                <div>
                  <h5 className="font-semibold">支付技术服务费</h5>
                  <p>申请前先完成支付，并<strong>备注：供应商报名服务费+公司名称</strong>；如需发票请使用对公转账</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <span className="w-6 h-6 bg-blue-100 text-blue-800 rounded-full flex items-center justify-center text-xs font-bold">2</span>
                <div>
                  <h5 className="font-semibold">提交申请</h5>
                  <p>在线填写并提交供应商入围申请表，上传相关资质文件</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <span className="w-6 h-6 bg-blue-100 text-blue-800 rounded-full flex items-center justify-center text-xs font-bold">3</span>
                <div>
                  <h5 className="font-semibold">资质审核</h5>
                  <p>公司采购部门在确认收款后对提交的资料进行审核</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <span className="w-6 h-6 bg-blue-100 text-blue-800 rounded-full flex items-center justify-center text-xs font-bold">4</span>
                <div>
                  <h5 className="font-semibold">现场考察</h5>
                  <p>对通过初审的供应商进行现场考察和评估</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <span className="w-6 h-6 bg-blue-100 text-blue-800 rounded-full flex items-center justify-center text-xs font-bold">5</span>
                <div>
                  <h5 className="font-semibold">入围公示</h5>
                  <p>审核通过后在官网公示，正式成为入围供应商</p>
                </div>
              </div>
              <div className="bg-blue-50 p-3 rounded-lg mt-4">
                <p className="text-blue-800 text-xs">
                  审核周期：通常为15个工作日<br />
                  邮箱：452081898@qq.com
                </p>
              </div>
            </div>
          )}

          {activeTab === "benefits" && (
            <div className="space-y-3">
              <p>• <strong>稳定订单</strong>：获得持续采购机会，优先参与新项目</p>
              <p>• <strong>技术合作</strong>：参与技术创新，共享研发成果</p>
              <p>• <strong>品牌提升</strong>：提升企业形象与市场竞争力</p>
              <p>• <strong>付款保障</strong>：享受优质付款条件，保障资金流</p>
              <p>• <strong>质量优先</strong>：优质供应商获更多合作机会</p>
              <p>• <strong>共同发展</strong>：参与公司战略，共享行业红利</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuppliersLeftPanel;